export default __webpack_public_path__ + "0fccf20bffad3b99c9e02cd0e59cd75d.svg";